<template>
  <div class="pause-bar-box">
    <div class="pause-bar-info">
      {{
        $t('FoodC_pause_cYix_reoR', {
          brand: brandName,
          date: pauseStartDate,
        })
      }}
      <span class="rule" @click="handlePauseInfoClick">{{ $t('FoodC_update_ZFGk_VVRa') }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    membership: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    pauseStartDate() {
      return this.membership?.pauseStartDate
    },
    brandName() {
      return this.membership?.brandName
    },
  },
  methods: {
    handlePauseInfoClick() {
      this.$router.push({
        path: '/member/pauseInfo',
        query: {
          nativeWebUIType: 1,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.pause-bar-box {
  margin: 20px;
  padding: 32px;
  background-color: #fff;
  border-radius: 40px;
  .pause-bar-info {
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #0b0b0d;
    letter-spacing: 0;
    line-height: 40px;
    font-weight: 400;
    .rule {
      text-decoration: underline;
      font-family: DiDiSans-Pro-Bold;
      font-size: 28px;
      color: #0b0b0d;
      letter-spacing: 0;
      line-height: 40px;
      font-weight: 700;
    }
  }
}
</style>
